import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import SelectAsync from 'react-select/async';

export default class RestaurantMenuCategory extends Base {
	constructor(props) {
		super(props);
		this.state = {
			caller: props.Caller,
			controllerName: 'restaurantmenucategory',
			refreshCallerAfterSave: this.isNull(props.RefreshCallerAfterSave) ? true : props.RefreshCallerAfterSave,
			id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
			data: null,
			loading: true,
			itemGridVersion: this.getDefaultGuid()
		};
		this.keyDownFunction = this.keyDownFunction.bind(this);
	}
	componentWillUnmount() {
		this.removeKeyDown();
	}
	componentDidMount() {
		this.addKeyDown();
		this.refreshData();
	}
	save(e) {
		e.preventDefault();

		this.httpPost("api/v1/restaurantmenucategory/save", {
			id: this.state.id,
			organizationId: this.state.data.global.company.id,
			name: this.state.data.record.name,
			isActiveInSide: this.state.data.record.isActiveInSide,
			isActiveOutSide: this.state.data.record.isActiveOutSide,
			description: this.state.data.record.description,
			items: this.state.data.record.items
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("دسته با موفقیت ذخیره شد");

					if (this.state.refreshCallerAfterSave)
						this.state.caller.refreshData();

					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	refreshData() {
		this.httpPost("api/v1/restaurantmenucategory/get", {
			id: this.state.id,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					window.organizationId = data.global.company.id;
					this.state.data = data;
					this.state.loading = false;
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	addNewItem() {
		var item = {
			id: this.uuidv4(),
			stuffId: this.getDefaultGuid(),
			stuffName: '',
			name: '',
			isActiveInSide : false,
			isActiveOutSide: false,
		}
		this.state.data.record.items.push(item);
		this.setState({ itemGridVersion: this.uuidv4() });
	}
	removeItem(id) {
		var temp = [];
		this.state.data.record.items.forEach(ow => {
			if (ow.id !== id) temp.push(ow);
		});
		this.state.data.record.items = temp;
		this.setState({ itemGridVersion: this.uuidv4() });
	}
	setItemValue(id, e , f) {
		this.state.data.record.items.forEach(ow => {
			if (ow.id === id) {
				if (f == 'stuffId') {
					ow.stuffId = e.value;
					ow.stuffName = e.label;
					if (this.isBlank(ow.name)) ow.name = e.name;
				}
				else {
					ow[f] = e;
				}
			}
		});
		this.setState({ itemGridVersion: this.uuidv4() });
	}
	renderForm() {
		return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
			<div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
			<div className="modal-dialog ui-draggable" style={{ "width": "96%", "left": "7.125px", "top": "-2px" }}>
				<div className="modal-content">
					<div className="modal-body">
						<div className="modal-header modal-header-info" style={{ "padding": "0" }}>
							<button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
							<h4 className="modal-title">دسته منو</h4>
						</div>
						<div className="modal-body" style={{ "display": "flex", "flex-direction": "column", "gap": "10px" }}>

							<div className="tab-content">
								<div className="row">
									<div className="col-sm-3">
										<div className="form-group">
											<label for="invoiceNumber" className="title1">عنوان</label>
											<input onChange={e => this.state.data.record.name = e.target.value} defaultValue={this.state.data.record.name} type="text" className="form-control input-smnumber" />
										</div>
									</div>
									<div className="col-sm-9">
										<div className="form-group">
											<label for="invoiceNumber" className="title1">توضیحات</label>
											<input onChange={e => this.state.data.record.description = e.target.value} defaultValue={this.state.data.record.description} type="text" className="form-control input-smnumber" />
										</div>
									</div>
									<div className="col-sm-3">
										<div className="form-group">
											<input onChange={e => this.state.data.record.isActiveInSide = e.target.checked} defaultChecked={this.state.data.record.isActiveInSide} type="checkbox" />
											فروش در داخل مجموعه
										</div>
									</div>
									<div className="col-sm-3">
										<div className="form-group">
											<input onChange={e => this.state.data.record.isActiveOutSide = e.target.checked} defaultChecked={this.state.data.record.isActiveOutSide} type="checkbox" />
											فروش در خارج از مجموعه
										</div>
									</div>
								</div>
								<div className="row">
									<div className="col-sm-12">
										<p>کالاهایی که میخواهید در این دسته منو نمایش داده شوند را انتخاب نمایید</p>
										<table className="table table-bordered table-hover acc_grid_row">
											<thead>
												<tr className="active">
													<td>کالا</td>
													<td>عنوان نمایشی</td>
													<td style={{ "width": "150px" }}>داخل مجموعه</td>
													<td style={{ "width": "150px" }}>خارج مجموعه</td>
													<td style={{ "width": "35px" }}></td>
												</tr>
											</thead>
											<tbody>
												{this.state.data.record.items.map(item =>
													<tr key={item.id}>
														<td>
															<SelectAsync
																style={{ "width": "100%" }}
																defaultValue={item.stuffId != this.defaultGuid() ? [{ value: item.stuffId, label: item.stuffName }] : null}
																isMulti={false}
																placeholder="انتخاب کالا"
																noOptionsMessage={({ inputValue }) =>
																	inputValue ? "نتیجه‌ای یافت نشد" : null
																}
																components={{
																	DropdownIndicator: () => null,
																	IndicatorSeparator: () => null,
																}}
																defaultOptions={[]}
																loadOptions={(inputValue, callback) => this.loadStuffsOptions(inputValue, callback)}
																onChange={e => this.setItemValue(item.id, e,'stuffId')}
															/>
														</td>
														<td>
															<input
																type="text"
																className="form-control persian-date"
																placeholder={"عنوان"}
																onChange={(e) => { this.setItemValue(item.id, e.target.value,'name') }}
																defaultValue={item.name}
															/>
														</td>
														<td>
															<input
																type="checkbox"
																onChange={(e) => { this.setItemValue(item.id, e.target.checked, 'isActiveInSide') }}
																defaultChecked={item.isActiveInSide}
															/>
														</td>
														<td>
															<input
																type="checkbox"
																onChange={(e) => { this.setItemValue(item.id, e.target.checked, 'isActiveOutSide') }}
																defaultChecked={item.isActiveOutSide}
															/>
														</td>
														<td>
															<span title="حذف سطر" onClick={e => this.removeItem(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>
														</td>
													</tr>
												)}
											</tbody>
										</table>
										<a className="btn btn-primary" onClick={e => this.addNewItem()}>افزودن کالای جدید</a>
									</div>
								</div>
							</div>

						</div>
						<div className="modal-footer">
							<button type="button" className="hand btn btn-primary" onClick={e => this.save(e)} >ذخیره</button>
							<a className="btn btn-warning" onClick={e => this.closeMe()}>انصراف</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />
		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.getGlobalContainer(),
				<Header data={this.state.data} />,
				this.renderForm(),
				this.renderPopupComponent()
			];

		return contents;
	}
}